export default "__VITE_ASSET__ksuEqxgd__"